import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-35403e18"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "app" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "content" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Panel de Indicadores", -1 /* HOISTED */));
const _hoisted_5 = { class: "toggle-buttons" };
const _hoisted_6 = { class: "stats-grid" };
const _hoisted_7 = { class: "stat-card confirmed" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-icon" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check-circle" })
], -1 /* HOISTED */));
const _hoisted_9 = { class: "card-details" };
const _hoisted_10 = { class: "stat-value" };
const _hoisted_11 = { class: "stat-card annual" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-icon" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-calendar-year" })
], -1 /* HOISTED */));
const _hoisted_13 = { class: "card-details" };
const _hoisted_14 = { class: "stat-value" };
const _hoisted_15 = { class: "stat-card monthly" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-icon" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-calendar-month" })
], -1 /* HOISTED */));
const _hoisted_17 = { class: "card-details" };
const _hoisted_18 = { class: "stat-value" };
const _hoisted_19 = { class: "stat-card projected" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-icon" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-chart-line" })
], -1 /* HOISTED */));
const _hoisted_21 = { class: "card-details" };
const _hoisted_22 = { class: "stat-value" };
const _hoisted_23 = { class: "chart-section" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_SalesChart = _resolveComponent("SalesChart");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" Header "),
        _createVNode(_component_Header),
        _createCommentVNode(" Sidebar y Contenido Principal "),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createCommentVNode(" Contenido Principal "),
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createCommentVNode(" Botón para Alternar entre Órdenes e Ingresos "),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                        class: _normalizeClass({ active: $setup.view === 'orders' }),
                        onClick: _cache[0] || (_cache[0] = ($event) => ($setup.view = 'orders'))
                    }, " Órdenes ", 2 /* CLASS */),
                    _createElementVNode("button", {
                        class: _normalizeClass([{ active: $setup.view === 'revenue' }, "ms-2"]),
                        onClick: _cache[1] || (_cache[1] = ($event) => ($setup.view = 'revenue'))
                    }, " Ingresos ", 2 /* CLASS */)
                ]),
                _createCommentVNode(" Sección de Tarjetas de Estadísticas "),
                _createElementVNode("div", _hoisted_6, [
                    _createCommentVNode(" Tarjeta de Ingresos Confirmados "),
                    _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("h3", null, _toDisplayString($setup.view === 'orders' ? 'Órdenes Pendientes' : 'Ingresos últimos 7 Días'), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_10, _toDisplayString($setup.view === 'orders' ? '0' : '$0'), 1 /* TEXT */)
                        ])
                    ]),
                    _createCommentVNode(" Tarjeta de Ingresos Anuales "),
                    _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("h3", null, _toDisplayString($setup.view === 'orders' ? 'Órdenes en Proceso' : 'Ingresos este Mes'), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_14, _toDisplayString($setup.view === 'orders' ? '0' : '$0'), 1 /* TEXT */)
                        ])
                    ]),
                    _createCommentVNode(" Tarjeta de Ingresos Mensuales "),
                    _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("h3", null, _toDisplayString($setup.view === 'orders' ? 'Órdenes Completadas' : 'Ingresos este Año'), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_18, _toDisplayString($setup.view === 'orders' ? '0' : '$0'), 1 /* TEXT */)
                        ])
                    ]),
                    _createCommentVNode(" Tarjeta de Ingresos Proyectados "),
                    _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("h3", null, _toDisplayString($setup.view === 'orders' ? 'Órdenes Canceladas' : 'Ingresos Totales'), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_22, _toDisplayString($setup.view === 'orders' ? '0' : '$0'), 1 /* TEXT */)
                        ])
                    ])
                ]),
                _createCommentVNode(" Gráfico de Ventas Mensuales "),
                _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("h2", null, _toDisplayString($setup.view === 'orders' ? 'Gráfico de Órdenes Mensuales' : 'Gráfico de Ingresos Mensuales'), 1 /* TEXT */),
                    _createVNode(_component_SalesChart, { chartType: $setup.view }, null, 8 /* PROPS */, ["chartType"])
                ])
            ])
        ])
    ]));
}
